import formatNumber from "format-number";
export var formatCurrency = function formatCurrency(value) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _options$unit = options.unit,
    unit = _options$unit === void 0 ? "€" : _options$unit;
  return formatNumber({
    decimal: ",",
    integerSeparator: ".",
    round: 2,
    padRight: 2,
    suffix: " " + unit
  })(value);
};